import { Check } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';
import { cn } from '@/lib/utils';
import { useStepper } from './stepper-provider';

const StepVerticalTrackBar = () => {
  const { currentStep, totalSteps, goToStep, completedSteps, getSteps } = useStepper();

  return (
    <div>
      {getSteps().map((step, index) => {
        const isCompleted = completedSteps.includes(step.id);
        const isCurrent = currentStep === step.id;

        return (
          <div className="relative flex flex-col [&:not(:last-child)]:flex-1" key={step.id}>
            <div className="flex items-center gap-2">
              <Button
                type="button"
                variant="ghost"
                className={cn(
                  'h-8 w-8 rounded-full border p-0 text-lg font-bold text-gray-300',
                  (isCurrent || isCompleted) && 'border-gray-700 text-foreground'
                )}
                onClick={() => goToStep(step.id)}
              >
                {isCompleted ? <Check size={18} /> : step.id}
              </Button>
              <div
                className={cn(
                  'ml-4 text-base font-medium text-gray-300',
                  (isCurrent || isCompleted) && 'text-foreground'
                )}
              >
                {step.title}
              </div>
            </div>
            {index !== totalSteps - 1 && (
              <div className={cn('my-2 ml-4 h-11 w-px bg-gray-300', isCompleted && 'bg-gray-700')} />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StepVerticalTrackBar;
